import laoApp from 'assets/images/footer-laoapp.svg'
import logo from 'assets/images/logo.svg'
import { FooterGameSVG, FooterProfileSVG } from 'assets/svg/FooterSVG'
import {
	HeaderPrizeSVG,
	HeaderRankSVG,
	HeaderShopSVG,
} from 'assets/svg/HeaderSVG'
import { PATHS } from 'config/routes'
import { useCheckSub } from 'dataLayer/game'
import { getSettingQuery, getUserQuery } from 'dataLayer/user'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { Link, NavLink } from 'react-router-dom'
import { getUserinfo } from 'utils/localStorage'

function LeftMenu({ handleCloseDrawer }) {
	const { t } = useTranslation()
	const userInfo = getUserinfo();
	const { data: user } = useQuery(getUserQuery())
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
	const { data: helpData } = useQuery(getSettingQuery())
	let listHelpData = []
	helpData &&
		helpData.map(it => {
			switch (it.type) {
				// case 'term-condition':
				// 	it = { ...it, name: t('footer.term_condition') }
				// 	listHelpData.push(it)
				// 	break
				// case 'intro':
				// 	it = { ...it, name: t('footer.intro') }
				// 	listHelpData.push(it)
				// 	break
				case 'contact':
					it = { ...it, name: t('footer.contact') }
					listHelpData.push(it)
					break
				// case 'term-privacy':
				// 	it = { ...it, name: t('footer.receive') }
				// 	listHelpData.push(it)
				// 	break
				// case 'summary':
				// 	it = { ...it, name: t('footer.summary') }
				// 	listHelpData.push(it)
				// 	break
				case 'faq':
					it = { ...it, name: t('footer.faq') }
					listHelpData.push(it)
					break
				default:
					break
			}
		})

	const { mutate: mutateCheckSub, isLoading: isCheckingSub } = useCheckSub(data => {
		if (data?.responseCode === '200') {
			window.location.href = data?.data?.urlWebView
		}
	})

	const handleYes = () => {
		if (isCheckingSub) return
		mutateCheckSub({ location: 'HOME', from: "" })
	}

	return (
		<div
			onClick={handleCloseDrawer()}
			onKeyDown={handleCloseDrawer()}
			className="box-left_menu"
			role="presentation"
		>
			<div className="logo-left_menu">
				<Link to={PATHS.HOME_PAGE}>
					<img alt="Logo's website" src={logo} width="95" height="38" />
				</Link>
			</div>

			<Container fluid className="container-left_menu">
				<Navbar>
					{/* <Nav className="nav-left_menu">
						<NavLink to={PATHS.HOME_PAGE} className="navlink-left_menu">
							<FooterGameSVG width="20" height="20" viewBox="0 0 20 20" />
							{t('mobile.footer.game')}
						</NavLink>
						<NavLink to={
							!userInfo
								? `${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`
								: '/shop'
						}
							onClick={(e) => {
								if (userInfo) {
									e.preventDefault()
									handleYes()
								}
							}} replace className="navlink-left_menu">
							<HeaderShopSVG width="20" height="20" viewBox="0 0 18 14" />
							{t('header.shop')}
						</NavLink>
						<NavLink to={PATHS.PRIZE_PAGE} className="navlink-left_menu">
							<HeaderPrizeSVG width="22" height="20" viewBox="0 0 18 16" />
							{t('header.prize')}
						</NavLink>
						<NavLink to={PATHS.RANK_PAGE} className="navlink-left_menu">
							<HeaderRankSVG width="20" height="20" viewBox="0 0 18 16" />
							{t('header.rank')}
						</NavLink>
						{getUserinfo() ? (
							<NavLink
								className="navlink-left_menu"
								to={user ? PATHS.PROFILE_PAGE : PATHS.LOGIN_PASS_MOBILE}
							>
								<FooterProfileSVG width="20" height="20" viewBox="0 0 20 20" />
								{t('profile.profile')}
							</NavLink>
						) : (
							<Link
								to={`${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`}
								className="navlink-left_menu"
							>
								<FooterProfileSVG width="20" height="20" viewBox="0 0 20 20" />
								{t('profile.profile')}
							</Link>
						)}
					</Nav> */}
				</Navbar>
			</Container>

			<div className="footer-left_menu">
				<div className="contact-foot_left_menu">
					<ul className="footer-contact">
						{listHelpData &&
							listHelpData?.map(it => (
								<li>
									<Link to={PATHS.SETTING_PAGE.replace(':type', it?.type)}>
										{it.name}
									</Link>
								</li>
							))}
					</ul>
				</div>
				<div className="text-foot_left_menu">
					<img src={laoApp} alt="Footer logo" />
					<p>{t('footer.all_right')}</p>
					<p>{t('footer.content')}</p>
				</div>
			</div>
		</div>
	)
}

export default LeftMenu
